/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SelfAnalysis.vue?vue&type=template&id=857bb52e&scoped=true&"
import script from "./SelfAnalysis.vue?vue&type=script&lang=js&"
export * from "./SelfAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./SelfAnalysis.vue?vue&type=style&index=0&id=857bb52e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857bb52e",
  null
  
)

export default component.exports